module.exports = __webpack_public_path__ + "media/product/marker-ring-a05d86cc.png";